module.exports = __webpack_public_path__ + "static/media/Paradise-Bakery.196d477e.png";